import { toWSDateString } from "@wingspanhq/fe-component-library";

const ISO_DATETIME_PATTERN =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

/**
 * v3 audit-log changes carry raw JSON values with no accompanying data type, so
 * the presentation is inferred from the value itself. Datetimes are still
 * formatted (the legacy event store wrote them as ISO strings) — everything else
 * falls through to its plain string form.
 */
export const formatAttributeValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (Array.isArray(value)) {
    return value.map(formatAttributeValue).join(", ");
  }

  if (typeof value === "string") {
    return ISO_DATETIME_PATTERN.test(value) ? toWSDateString(value) : value;
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};
